import BaseFormWrapper from "./BaseFormWrapper.vue";

export * from "./BaseFormWrapper.vue";
export default BaseFormWrapper;
